export var productCodeCi1 = "BBNTCR00";
export var productCodeRopci = "BBNRCR00";
export var productCodeWP1 = "BBPWLR20";
export var productCodeES1 = "BBUSTR00";
export var productCodeTF1 = "BBNTLR11";
export var productCodeTL3 = "BBNTLR31";
export var productCode3in1 = "BBNRHR00";
export var productCodeD2 = "BBNMER41";
export var productCodeD2L = "BBNMER42";
